import { fireFlowLoadedAction } from 'src/dispatcher';
import PPF from 'src/components/PPF';

export default (config, flow) => {
  new PPF(flow.options);

  fireFlowLoadedAction({
    nodes: flow.parsedNodes,
    nodeId: config.nodeId,
    locales: flow.locales
  });
};
